export enum RoutesRouter {
  companies = "/home/companies",
  login = "/login",
  resetpassword = "/reset-password",
  addCompany = "/home/companies/create",
  template = "/home/survey/template",
  questions = "/home/survey/questions",
  addQuestion = "/home/survey/questions/create",
  addTemplate = "/home/survey/template/create",
  library = "/home/library",
  addLibrary = "/home/library/create",
  issue = "/home/issue",
  addIssue = "/home/issue/create",
}

export type IRoutesRouter = `${RoutesRouter}`;
